module.exports = __webpack_public_path__ + "static/media/SPEEDYICON-01.82a7f2ce.svg";